export const clone = <T>(v: T): T => JSON.parse(JSON.stringify(v));
export const deepEqual = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b);

export const getUrlDomainName = (url: string) => {
   const regex = /^https?:\/\/(?:www\.)?([a-z0-9]+(?:-[a-z0-9]+)*)\.nxtpeople\.jobs$/;
   const match = url.match(regex);
   return match ? match[1] : '';
};
